//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_GetRechargeList } from "../../../api";
import { conversion } from "../../../tool";

export default {
  name: "walletHistory",
  data() {
    return {
      walletData: {
        data: { list: [] },
        current: 1,
        size: 15,
      },
    };
  },
  methods: {
    getuserBalance(obj) {
      api_GetRechargeList(obj).then((res) => {
        if (res.data.code === 0) {
          this.walletData.data.list = res.data.data.data || [];
          this.walletData.data.total = res.data.data.totalItems || 0;
        }
      });
    },
    pageF(v) {
      this.getuserBalance({ page: v, size: this.walletData.size });
    },
  },
  filters: {
    conversion,
    add(v) {
      return v > 0 ? `+${v}` : v;
    },
  },
  created() {
    this.getuserBalance({
      page: this.walletData.current,
      size: this.walletData.size,
    });
  },
};
